import { ChangeEvent, useState } from 'react';
import { Radio, RadioGroup, Button, Box, Divider } from '@mui/material';
import { FileType } from '@/types';
import { GenericModal } from '@/components/shared/GenericModal/GenericModal';
import {
  DialogDescription,
  FileTypeRadioBox,
  StyledFormControlLabel,
  BorderedFormControlLabel,
  FileTypeLabelBox,
  DialogActions,
  genericModalStyles,
} from './styles';

type FileTypeDialogProps = {
  open: boolean;
  onConfirm?: (value: FileType) => void;
  setFileDialog: (isOpen: boolean) => void;
  location: string;
};

export const FileTypeDialog = ({
  open,
  onConfirm,
  setFileDialog,
  location = '',
}: FileTypeDialogProps) => {
  const [value, setValue] = useState(FileType.GENERAL);

  const onClose = () => {
    setFileDialog(false);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value as FileType);
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(value);
      setFileDialog(false);
    }
  };

  return (
    <GenericModal
      open={open}
      handleClose={onClose}
      title="File type"
      crossIconStyle={genericModalStyles.crossIconStyle}
      sx={genericModalStyles.sx}
      titleSx={genericModalStyles.titleSx}
      headerStyleProp={genericModalStyles.headerStyleProp}
    >
      <Box>
        <DialogDescription>
          Select the file type you are uploading. reference drawing files will be automatically converted to
          images.
        </DialogDescription>
        <RadioGroup value={value} onChange={handleChange}>
          <FileTypeRadioBox id={`${location}-reference-drawing-upload`}>
            <BorderedFormControlLabel
              value="Reference Drawing"
              control={<Radio size="small" />}
              label={
                <FileTypeLabelBox>
                  <img src="/assets/pdf-assets/pdf.png" width={24} height={24} />
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: '1.4rem',
                      color: 'var(--mui-palette-text-primary)',
                    }}
                  >
                    Reference Drawing (Isometric / P&ID)
                  </span>
                </FileTypeLabelBox>
              }
            />
          </FileTypeRadioBox>
          <FileTypeRadioBox id={`${location}-reference-document-upload`}>
            <StyledFormControlLabel
              value="reference document"
              control={<Radio size="small" />}
              label={
                <FileTypeLabelBox>
                  <img src="/assets/pdf-assets/pdf.png" width={24} height={24} />
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: '1.4rem',
                      color: 'var(--mui-palette-text-primary)',
                    }}
                  >
                    Reference Document
                  </span>
                </FileTypeLabelBox>
              }
            />
          </FileTypeRadioBox>
        </RadioGroup>
      </Box>
      <Divider sx={{ my: 0 }} />
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          CANCEL
        </Button>
        <Button onClick={handleConfirm} variant="contained">
          CONFIRM
        </Button>
      </DialogActions>
    </GenericModal>
  );
};
